<template>
  <section class="container">
    <img
      class="share-title"
      src="https://cdn.gelonghui.com/webActive/img_share_title.png"
      alt
    />
    <div class="user-infor">
      <img :src="userInfor.avatar" alt />
      <p class="user-name">{{ userInfor.nick }}</p>
      <p class="user-tips">送您黄金会员体验资格</p>
    </div>
    <img
      class="share-button"
      src="https://cdn.gelonghui.com/webActive/img_share_button.png"
      alt
    />
    <img
      class="share-equity"
      src="https://cdn.gelonghui.com/webActive/img_share_vipexplainth.png"
      alt
    />
    <section class="user-received">
      <ul>
        <li class="received-title">
          <span class="title-left">本月已领取</span>
          <span class="title-right">{{ userInfor.inviteCount }}/5</span>
          <table style="clear:both;"></table>
        </li>
        <li
          v-show="userInfor.inviteCount > 0"
          v-for="(item, index) in userInfor.invitePhoneList"
          :key="index"
          class="tel-list"
        >
          <p>{{ placePhone(item) }}</p>
        </li>
        <li v-if="userInfor.inviteCount === 0" class="no-list">
          <img src="https://cdn.gelonghui.com/webActive/img_share_not.png" />
          <p>暂无好友领取</p>
        </li>
      </ul>
    </section>
    <p>以上信息的最终解释权归格隆汇所有</p>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      deviceInfo: {
        userAgent: "",
        isInApp: false,
        isLogin: false,
        buyYear: true
      },
      userInfor: {},
      err: []
    };
  },
  components: {},
  mounted() {
    document.title = "分享给好友";
  },
  created() {
    this.checkDeviceInfo();
    this.getUserInfor();
  },
  methods: {
    goshare() {
      //---------------------分享
      console.log("我点了分享");
      let title = "你的好友送你格隆汇会员";
      let summary = "立享格隆汇会员专属权益体验";
      let url =
        window.location.origin +
        window.location.pathname +
        "#/share/" +
        this.userInfor.inviteCode;
      let image = "https://cdn.gelonghui.com/webActive/wechat-vip.png";
      let shareType = "article";
      // console.log({
      //   title: title,
      //   content: summary,
      //   url: url,
      //   image: image
      // })
      if (this.deviceInfo.isInApp) {
        if (this.deviceInfo.userAgent === "iOS") {
          let pass_data = {
            title: title,
            content: summary,
            url: url,
            image: image
          };
          pass_data = JSON.stringify(pass_data);
          try {
            window.webkit.messageHandlers.iosPresentSharePage.postMessage(
              pass_data
            );
          } catch (err) {
            console.log(err);
          }
        } else {
          try {
            window.NativeInterface.share(title, summary, url, image, shareType);
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        window.location.href =
          "https://www.gelonghui.com/app/device_redirect.html";
      }
    },
    placePhone(num) {
      return num.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    },
    getUserInfor() {
      axios({
        method: "get",
        url: "/api/vips/invite/info/v1",
        headers: {
          platform: `${this.deviceInfo.userAgent}`
        }
      })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.userInfor = res.data.result;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    checkDeviceInfo() {
      //----------------------------判断设备
      if (
        (window.NativeInterface && window.NativeInterface.isLogined) ||
        (window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.iosCheckIsLoggedIn)
      ) {
        this.deviceInfo.isInApp = true;
      } else {
        this.deviceInfo.isInApp = false;
      }
      let ua = navigator.userAgent.toLowerCase();
      //判断设备
      if (this.deviceInfo.isInApp) {
        if (/iphone|ipad|ipod/.test(ua)) {
          // 在ios里
          this.deviceInfo.userAgent = "iOS";
          // this.getIntroduction();
          let loginOut = false;
          window.iosIsLogin = result => {
            loginOut = result;
            this.deviceInfo.isLogin = result;
            this.isLogin = result;
          };
          window.webkit.messageHandlers.iosCheckIsAnyWayLogin.postMessage(
            "iosIsLogin"
          );
        } else if (/android/.test(ua)) {
          this.deviceInfo.userAgent = "android";
          let loginStatus = window.NativeInterface.isLogined();
        }
        this.getUserInfor();
      } else {
        // window.location.href =
        //   "https://www.gelonghui.com/app/device_redirect.html";
      }
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.container {
  position: relative;
  padding-bottom: 26px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  background: #282c37 url(https://cdn.gelonghui.com/webActive/img_bg.png)
    no-repeat;
  background-size: 100%;

  > .share-title,
  .share-equity {
    width: 100%;
  }

  > .share-button {
    width: 80%;
  }

  .user-infor {
    position: absolute;
    top: 140px;
    left: 0;
    text-align: center;
    width: 100%;

    > img {
      margin-top: 6px;
      width: 88px;
      border-radius: 50%;
    }

    .user-name {
      margin: 16px 0 18px 0;
      font-size: 34px;
      color: rgba(115, 81, 36, 1);
      line-height: 60px;
    }

    .user-tips {
      font-size: 26px;
      color: rgba(168, 127, 72, 1);
    }
  }

  .user-received {
    width: 100%;

    ul {
      width: 92%;
      margin: 0 auto;
      padding: 29px 0 20px;
      background: rgba(56, 62, 77, 1);
      box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;

      .received-title {
        padding: 0 39px 30px 39px;
      }

      .title-left {
        float: left;
        font-size: 36px;
        font-weight: 500;
        // line-height: 60px;
        color: rgba(255, 255, 255, 1);
      }

      .title-right {
        float: right;
        font-size: 28px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.5);
        // line-height: 60px;
      }

      .tel-list {
        padding: 0 39px;
        height: 107px;
        line-height: 107px;
        background: rgba(40, 44, 55, 0.2);
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        &:last-child {
          border: none;
        }

        p {
          text-align: left;
          margin-left: 15px;
          font-size: 34px;
          color: rgba(254, 254, 254, 1);
        }
      }

      .no-list {
        text-align: center;

        img {
          margin: 41px 0 29px 0;
          width: 100px;
        }

        p {
          font-size: 24px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }

  > p {
    margin-top: 40px;
    font-size: 20px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/index.vue